export * from './bn-customer-info-v2.module';
export * from './bn-customer-info-v2.component';
export { EntryResolver } from './bn-customer-info-v2.resolver';
export * from './services/bn-customer-info-v2.service';
